import {useEffect} from 'react';

const DEFAULT_TITLE = 'Continuum';

/**
 * Sets document.title to the given string. Restores the default title on unmount.
 */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title || DEFAULT_TITLE;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
